import { render, staticRenderFns } from "./integralRule.vue?vue&type=template&id=5251b941&scoped=true"
import script from "./integralRule.vue?vue&type=script&lang=ts"
export * from "./integralRule.vue?vue&type=script&lang=ts"
import style0 from "./integralRule.vue?vue&type=style&index=0&id=5251b941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251b941",
  null
  
)

export default component.exports